import { useLayoutEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Elemente, die beim Laden bereits im Viewport stehen (Hero-Zeilen auf großen Screens), animieren sofort – whileInView zündet dort nicht zuverlässig.
const useAutoImmediate = (immediate) => {
  const ref = useRef(null);
  const [now, setNow] = useState(immediate);
  useLayoutEffect(() => {
    if (immediate || !ref.current) return;
    const r = ref.current.getBoundingClientRect();
    if (r.top < window.innerHeight * 1.1 && r.bottom > 0) setNow(true);
  }, [immediate]);
  return [ref, now];
};

const trigger = (immediate, value) => (immediate ? { animate: value } : { whileInView: value });

export const LineMask = ({ children, delay = 0, className = "", immediate = false }) => {
  const [ref, now] = useAutoImmediate(immediate);
  return (
    <motion.span
      ref={ref}
      className={`block overflow-hidden ${className}`}
      initial="hidden"
      {...trigger(now, "show")}
      viewport={{ once: true, margin: "-8% 0px" }}
    >
      <motion.span
        className="block will-change-transform"
        variants={{
          hidden: { y: "115%" },
          show: { y: "0%", transition: { duration: 1.1, delay, ease: EASE } },
        }}
      >
        {children}
      </motion.span>
    </motion.span>
  );
};

export const FadeUp = ({ children, delay = 0, className = "", y = 40, immediate = false }) => {
  const [ref, now] = useAutoImmediate(immediate);
  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y }}
      {...trigger(now, { opacity: 1, y: 0 })}
      viewport={{ once: true, margin: "-10% 0px" }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
};

export const FadeIn = ({ children, delay = 0, className = "" }) => {
  const [ref, now] = useAutoImmediate(false);
  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0 }}
      {...trigger(now, { opacity: 1 })}
      viewport={{ once: true, margin: "-10% 0px" }}
      transition={{ duration: 1.4, delay, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};
